/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconShoppingCartOff = createReactComponent("outline", "shopping-cart-off", "IconShoppingCartOff", [["path", { "d": "M6 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M17 17a2 2 0 1 0 2 2", "key": "svg-1" }], ["path", { "d": "M17 17h-11v-11", "key": "svg-2" }], ["path", { "d": "M9.239 5.231l10.761 .769l-1 7h-2m-4 0h-7", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

export { IconShoppingCartOff as default };
//# sourceMappingURL=IconShoppingCartOff.mjs.map
